var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssetIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dataflow-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12 4.25635V15.4563C12 17.1365 12 17.9766 12.327 18.6183C12.6146 19.1828 13.0735 19.6417 13.638 19.9294C14.2798 20.2563 15.1198 20.2563 16.8 20.2563H17M17 20.2563C17 21.3609 17.8954 22.2563 19 22.2563C20.1046 22.2563 21 21.3609 21 20.2563C21 19.1518 20.1046 18.2563 19 18.2563C17.8954 18.2563 17 19.1518 17 20.2563ZM7 4.25635L17 4.25635M7 4.25635C7 5.36092 6.10457 6.25635 5 6.25635C3.89543 6.25635 3 5.36092 3 4.25635C3 3.15178 3.89543 2.25635 5 2.25635C6.10457 2.25635 7 3.15178 7 4.25635ZM17 4.25635C17 5.36092 17.8954 6.25635 19 6.25635C20.1046 6.25635 21 5.36092 21 4.25635C21 3.15178 20.1046 2.25635 19 2.25635C17.8954 2.25635 17 3.15178 17 4.25635ZM12 12.2563H17M17 12.2563C17 13.3609 17.8954 14.2563 19 14.2563C20.1046 14.2563 21 13.3609 21 12.2563C21 11.1518 20.1046 10.2563 19 10.2563C17.8954 10.2563 17 11.1518 17 12.2563Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetIcon);
export default __webpack_public_path__ + "static/media/asset-icon.addf175635d31939f679790303fb9ae3.svg";
export { ForwardRef as ReactComponent };